import { render, staticRenderFns } from "./ActivateCourse.vue?vue&type=template&id=b2e99ab8&"
import script from "./ActivateCourse.vue?vue&type=script&lang=js&"
export * from "./ActivateCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports